import styled from "styled-components";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { settings } from "../../../../../helpers/toast.settings";
import { useFormik } from "formik";
import { StyledButton } from "../../../../../components/Button/button";
import { addOfferPosition } from "../../../../../services/offers/position-add";
import { ObjectTypesArray, ServicesTypesArray } from "./helpers";
import * as yup from "yup";
interface OfferingPositionAddFormProps {
  subcontractorOfferId: string | undefined;
}
const OfferingPositionAddForm = ({
  subcontractorOfferId,
}: OfferingPositionAddFormProps) => {
  const AddOfferPositionMutation = useMutation(addOfferPosition, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", {
        toastId: "AddOfferPositionSuccessfully",
        ...settings,
      });
    },
  });
  const validationSchema = yup.object({
    dlugosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Długość jest wymagana"),
    szerokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Szerokość jest wymagana"),
    wysokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Wysokość jest wymagana"),
    cena_docelowa: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Cena jest wymagana"),
    ilosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Ilość jest wymagana"),
  });
  const formik = useFormik({
    initialValues: {
      cena_docelowa: 1,
      ilosc: 1,
      usluga: 0,
      obiekt: 2,
      dlugosc: 1,
      szerokosc: 1,
      wysokosc: 1,
      jednostka_dlugosci: 2,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const isEurPalete =
        formik.values.obiekt === 2 || formik.values.obiekt === 3 ? true : false;
      const body = {
        oferta_podwykonawcy_id: subcontractorOfferId,
        usluga: formik.values.usluga,
        cena_docelowa: formik.values.cena_docelowa,
        obiekt: formik.values.obiekt,
        ilosc: formik.values.ilosc,
        dlugosc: isEurPalete ? null : formik.values.dlugosc,
        szerokosc: isEurPalete ? null : formik.values.szerokosc,
        wysokosc: isEurPalete ? null : formik.values.wysokosc,
        jednostka_dlugosci: formik.values.jednostka_dlugosci,
      };

      AddOfferPositionMutation.mutate(body);
    },
  });

  return (
    <PackageTypeSummaryContainer onSubmit={formik.handleSubmit}>
      <>
        <FormControl fullWidth>
          <InputLabel id="usluga-label">Usługa</InputLabel>
          <Select
            placeholder="Usługa"
            labelId="usluga-label"
            label="usluga"
            id="usluga"
            name="usluga"
            value={formik.values.usluga}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            {ServicesTypesArray.map((item, index) => (
              <MenuItem value={index}>{item}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ marginTop: "20px" }} fullWidth>
          <InputLabel id="obiekt-label">Obiekt</InputLabel>
          <Select
            placeholder="Obiekt"
            labelId="obiekt-label"
            label="obiekt"
            id="obiekt"
            name="obiekt"
            value={formik.values.obiekt}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            {ObjectTypesArray.map((item, index) => (
              <MenuItem value={index}>{item}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {formik.values.obiekt !== 2 && formik.values.obiekt !== 3 && (
          <>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="dlugosc"
                name="dlugosc"
                value={formik.values.dlugosc}
                onChange={formik.handleChange}
                error={formik.touched.dlugosc && Boolean(formik.errors.dlugosc)}
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-dlugosc-helper-text"
                inputProps={{
                  "aria-label": "dlugosc",
                }}
              />
              <FormHelperText id="filled-dlugosc-helper-text">
                Długoość
              </FormHelperText>
            </FormControl>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="szerokosc"
                name="szerokosc"
                value={formik.values.szerokosc}
                onChange={formik.handleChange}
                error={
                  formik.touched.szerokosc && Boolean(formik.errors.szerokosc)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-szerokosc-helper-text"
                inputProps={{
                  "aria-label": "szerokosc",
                }}
              />
              <FormHelperText id="filled-szerokosc-helper-text">
                Szerokość
              </FormHelperText>
            </FormControl>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="wysokosc"
                name="wysokosc"
                value={formik.values.wysokosc}
                onChange={formik.handleChange}
                error={
                  formik.touched.wysokosc && Boolean(formik.errors.wysokosc)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-wysokosc-helper-text"
                inputProps={{
                  "aria-label": "wysokosc",
                }}
              />
              <FormHelperText id="filled-wysokosc-helper-text">
                Wysokość
              </FormHelperText>
            </FormControl>
          </>
        )}

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="cena_docelowa"
            name="cena_docelowa"
            value={formik.values.cena_docelowa}
            onChange={formik.handleChange}
            error={
              formik.touched.cena_docelowa &&
              Boolean(formik.errors.cena_docelowa)
            }
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">zł.</InputAdornment>}
            aria-describedby="filled-cena_docelowa-helper-text"
            inputProps={{
              "aria-label": "cena_docelowa",
            }}
          />
          <FormHelperText id="filled-cena_docelowa-helper-text">
            Cena
          </FormHelperText>
        </FormControl>

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="ilosc"
            name="ilosc"
            value={formik.values.ilosc}
            onChange={formik.handleChange}
            error={formik.touched.ilosc && Boolean(formik.errors.ilosc)}
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">szt.</InputAdornment>}
            aria-describedby="filled-ilosc-helper-text"
            inputProps={{
              "aria-label": "ilosc",
            }}
          />
          <FormHelperText id="filled-ilosc-helper-text">Ilość</FormHelperText>
        </FormControl>
        <SubmitButtonWrapper>
          <StyledButton
            disabled={!formik.isValid}
            type="submit"
            variant="contained"
            sx={{ width: "100%" }}
          >
            Zapisz
          </StyledButton>
        </SubmitButtonWrapper>
      </>
    </PackageTypeSummaryContainer>
  );
};

export default OfferingPositionAddForm;

const PackageTypeSummaryContainer = styled.form`
  width: 50%;
  flex-wrap: wrap;
  gap: 6px;
  @media (max-width: 500px) {
    width: 70%;
  }

  @media (max-width: 1143px) {
    justify-content: center;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 3%;
  border-radius: 10px;
`;
const SubmitButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`;
const StyledSummaryInput = styled(FilledInput)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
